import React from 'react';
import API_URL from '../config';
import './Avatar.css';

// Ronde profielfoto, of (zonder foto) een cirkeltje met de beginletter(s) van
// de naam. "url" is het relatieve pad uit de backend (bv. /uploads/user-photos/..).
function Avatar({ url, name, size = 32, className = '' }) {
  const src = url ? (/^https?:/.test(url) ? url : `${API_URL}${url}`) : null;
  const initials = (name || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  return src ? (
    <img className={`avatar ${className}`} src={src} alt={name || ''} style={style} />
  ) : (
    <span className={`avatar avatar-initials ${className}`} style={style} aria-hidden="true">{initials}</span>
  );
}

export default Avatar;
